import React from "react";
import { useDropzone } from "react-dropzone";
import { Box } from "@mui/material";

const FileUploadComp = ({ fileUploadProps, files, setFiles }) => {
  const handleDropEvent = (acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  };
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
    maxFiles: fileUploadProps.maxNumber,
    onDrop: handleDropEvent,
  });

  return (
    <Box
      sx={{
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "4px",
        padding: 2,
      }}
    >
      <Box
        {...getRootProps({ className: "dropzone" })}
        sx={{
          backgroundColor: "rgba(255,255,255,0.08)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderWidth: "2px",
          borderColor: "rgba(255,255,255,0.3)",
          borderStyle: "dashed",
          borderRadius: "4px",
          alignItems: "center",
          padding: 3,
          cursor: "pointer",
          "&:hover": {
            borderColor: "rgba(255,255,255,0.6)",
            backgroundColor: "rgba(255,255,255,0.1)",
          },
        }}
      >
        <input {...getInputProps()} />
        <Box
          component="h3"
          sx={{
            margin: 0,
            fontSize: "0.85rem",
            color: "#fff",
            fontWeight: 500,
          }}
        >
          Drag {fileUploadProps.maxNumber} picture here, or click to select picture
        </Box>
        <Box
          component="p"
          sx={{
            margin: "10px 0 0",
            fontSize: "0.8rem",
            color: "rgba(255,255,255,0.7)",
          }}
        >
          {`Please upload maximum of ${fileUploadProps.maxNumber} photo in jpeg, png format.`}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 1,
          padding: "12px 8px 0",
        }}
      >
        {files.length > 0 &&
          files.map((file, i) => (
            <Box
              key={i}
              component="img"
              alt="preview"
              src={file.preview}
              sx={{
                height: 100,
                width: 100,
                objectFit: "cover",
                borderRadius: "4px",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            />
          ))}
      </Box>
    </Box>
  );
};

export default FileUploadComp;
